var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaixar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.422,313v8.959a1.291,1.291,0,0,1-1.289,1.289H3.867a1.291,1.291,0,0,1-1.289-1.289V313H0v8.959a3.872,3.872,0,0,0,3.867,3.867H29.133A3.872,3.872,0,0,0,33,321.959V313Z",
    transform: "translate(0 -313)",
    fill: "#bcc8d1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.914,15.193l-4.9,4.9V0h-2.578V20.091l-4.9-4.9-1.823,1.823,8.01,8.01,8.01-8.01Z",
    transform: "translate(-131.716)",
    fill: "#bcc8d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaixar);
export default __webpack_public_path__ + "static/media/baixar.68f6dd20713e31b8dc4392092d073599.svg";
export { ForwardRef as ReactComponent };